<div class="quote-shell container py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10">
      <div class="quote-card">

        <!-- HEADER -->
        <div class="quote-head d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
          <div class="d-flex align-items-center gap-3">
            <img class="brand-logo" src="/assets/logo-sami.png" alt="Logo SAMI Pulizie" loading="lazy" />
            <div>
              <h2 class="mt">Lavora con noi</h2>
              <p class="m-0 text-muted small">
                Invia la tua candidatura con CV allegato. Ti contatteremo appena possibile.
              </p>
            </div>
          </div>

          <div class="quote-badges d-flex gap-2 flex-wrap justify-content-md-end">
            <span class="badge-soft badge-blue"><i class="fa-solid fa-people-group me-1"></i> Team serio</span>
            <span class="badge-soft badge-pink"><i class="fa-solid fa-briefcase me-1"></i> Opportunità</span>
            <span class="badge-soft badge-dark"><i class="fa-solid fa-file-arrow-up me-1"></i> CV allegato</span>
          </div>
        </div>

        <hr class="my-3" />

        <!-- FORM -->
        <form (ngSubmit)="onSubmit(formRef)" #formRef="ngForm" novalidate>
          <div class="row g-3">

            <div class="col-12 col-md-6">
              <label class="form-label" for="nome">Nome *</label>
              <input
                class="form-control"
                [class.is-invalid]="nome.invalid && (nome.dirty || nome.touched)"
                type="text"
                id="nome"
                name="nome"
                [(ngModel)]="formData.nome"
                required
                minlength="2"
                #nome="ngModel"
                placeholder="Es. Mario"
              />
              <div class="invalid-feedback">Inserisci un nome valido.</div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="cognome">Cognome *</label>
              <input
                class="form-control"
                [class.is-invalid]="cognome.invalid && (cognome.dirty || cognome.touched)"
                type="text"
                id="cognome"
                name="cognome"
                [(ngModel)]="formData.cognome"
                required
                minlength="2"
                #cognome="ngModel"
                placeholder="Es. Rossi"
              />
              <div class="invalid-feedback">Inserisci un cognome valido.</div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="email">Email *</label>
              <input
                class="form-control"
                [class.is-invalid]="email.invalid && (email.dirty || email.touched)"
                type="email"
                id="email"
                name="email"
                [(ngModel)]="formData.email"
                required
                email
                samiRealEmail
                [ngModelOptions]="{ updateOn: 'blur' }"
                #email="ngModel"
                placeholder="nome@email.it"
              />
              <div class="invalid-feedback" *ngIf="email.errors?.['providerTypo']">
                Il dominio sembra errato. Intendevi {{ email.errors?.['providerTypo'].suggestion }}?
              </div>
              <div class="invalid-feedback" *ngIf="email.errors?.['emailDomainMissing']">
                Questo dominio email non risulta esistente. Controlla l’indirizzo.
              </div>
              <div class="invalid-feedback" *ngIf="email.errors?.['required'] || email.errors?.['email']">
                Inserisci un’email valida.
              </div>
              <div class="form-text" *ngIf="email.pending">Verifica del dominio email…</div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="telefono">Telefono *</label>
              <input
                class="form-control"
                [class.is-invalid]="telefono.invalid && (telefono.dirty || telefono.touched)"
                type="tel"
                id="telefono"
                name="telefono"
                [(ngModel)]="formData.telefono"
                required
                minlength="8"
                #telefono="ngModel"
                placeholder="Es. 351 503 4934"
              />
              <div class="invalid-feedback">Inserisci un numero valido.</div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="ruolo">Ruolo desiderato</label>
              <input
                class="form-control"
                type="text"
                id="ruolo"
                name="ruolo"
                [(ngModel)]="formData.ruolo"
                placeholder="Es. Addetto/a pulizie, Caposquadra..."
              />
              <div class="hint mt-1">Facoltativo, ma utile.</div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label" for="disponibilita">Disponibilità</label>
              <input
                class="form-control"
                type="text"
                id="disponibilita"
                name="disponibilita"
                [(ngModel)]="formData.disponibilita"
                placeholder="Es. Full-time, Part-time, Turni..."
              />
            </div>

            <div class="col-12">
              <label class="form-label" for="messaggio">Messaggio</label>
              <textarea
                class="form-control"
                id="messaggio"
                name="messaggio"
                [(ngModel)]="formData.messaggio"
                rows="4"
                placeholder="Raccontaci brevemente la tua esperienza e perché vuoi lavorare con noi..."
              ></textarea>
              <div class="hint mt-1">Facoltativo.</div>
            </div>

            <!-- CV -->
            <div class="col-12">
              <label class="form-label" for="cv">Allega CV *</label>
              <input
                class="form-control"
                type="file"
                id="cv"
                name="cv"
                accept=".pdf,.doc,.docx"
                (change)="onCvChange($event)"
              />

              <div class="hint mt-1" *ngIf="cvName">
                File selezionato: <strong>{{ cvName }}</strong>
              </div>

              <div class="alert alert-danger mt-2 mb-0" *ngIf="cvError">
                {{ cvError }}
              </div>
            </div>

            <!-- PRIVACY -->
            <div class="col-12">
              <div class="privacy-row">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="privacy"
                  name="privacy"
                  [checked]="privacyAccepted"
                  (click)="onPrivacyClick($event)"
                  required
                />
                <label class="form-check-label" for="privacy">
                  Ho letto e accetto la
                  <a href="/privacy" (click)="openPrivacy($event)">Privacy Policy</a>
                </label>
              </div>
              <div class="small text-muted mt-1">
                I dati vengono usati solo per gestire la candidatura e ricontattarti.
              </div>
            </div>

            <!-- CTA -->
            <div class="col-12">
              <app-turnstile action="sami_career" (tokenChange)="turnstileToken = $event" />
            </div>

            <div class="col-12 d-grid d-md-flex gap-2 justify-content-md-end mt-2">
              <button type="button" class="btn btn-outline-brand" (click)="resetForm(formRef)" [disabled]="loading">
                Svuota
              </button>

              <button
                type="submit"
                class="btn btn-brand"
                [disabled]="formRef.invalid || !privacyAccepted || !turnstileToken || loading || !cvFile"
              >
                <span *ngIf="!loading"><i class="fa-solid fa-paper-plane me-2"></i>Invia candidatura</span>
                <span *ngIf="loading"><i class="fa-solid fa-circle-notch fa-spin me-2"></i>Invio...</span>
              </button>
            </div>

            <div class="col-12" *ngIf="successMsg">
              <div class="alert alert-success mb-0">{{ successMsg }}</div>
            </div>

            <div class="col-12" *ngIf="errorMsg">
              <div class="alert alert-danger mb-0">{{ errorMsg }}</div>
            </div>

          </div>
        </form>

      </div>
    </div>
  </div>
</div>

<!-- MODAL PRIVACY -->
<div class="privacy-modal" *ngIf="showPrivacyModal" (click)="closePrivacy()">
  <div class="privacy-modal-content" (click)="$event.stopPropagation()">
    <div class="d-flex align-items-start justify-content-between gap-3">
      <h3 class="m-0">Informativa Privacy</h3>
      <button class="icon-btn" type="button" (click)="closePrivacy()" aria-label="Chiudi">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="policy-content mt-3">
      <p class="mb-2">
        Ai sensi del Regolamento UE 2016/679 (GDPR), i dati inseriti verranno trattati esclusivamente
        per gestire la candidatura e ricontattarti.
      </p>
      <ul class="mb-2">
        <li>Nessuna cessione a terzi.</li>
        <li>Conservazione limitata al tempo necessario alla gestione della candidatura.</li>
        <li>Titolare del trattamento: <strong>SAMI Pulizie</strong>.</li>
      </ul>
      <p class="mb-0">
        Puoi leggere l’informativa completa nella pagina <a href="/privacy" target="_blank" rel="noopener">Privacy Policy</a>.
      </p>
    </div>

    <button class="btn btn-brand w-100 mt-3" (click)="acceptPrivacy()">
      ACCETTO
    </button>
  </div>
</div>
